import { useDispatch } from 'utils/hooks'
import { Button, Table, Flex } from '@jisr-hr/design-system'
import { employeesInviteLoad } from 'redux/organizationOnborading/invite/actionCreators'
import i18n from 'translations/i18n'
import { useState } from 'react'
import { TExtendsEmployee } from 'redux/organizationOnborading/employees/employees.type'
import { Typography } from '@jisr-hr/ds'

function Row({ row }: { row: TExtendsEmployee }): JSX.Element {
  const [hovered, setHovered] = useState(false)
  const dispatch = useDispatch()

  return (
    <Table.Row
      onMouseEnter={(): void => setHovered(true)}
      onMouseLeave={(): void => setHovered(false)}
    >
      <Table.Cell>
        <Flex flexCol>
          <Typography
            variant="subtitle-2"
            text={row.full_name_i18n}
          />
          <Typography
            variant="subtitle-2"
            text={row.code}
          />
        </Flex>
      </Table.Cell>
      <Table.Cell>{row.email}</Table.Cell>
      <Table.Cell style={{ width: 160 }}>
        <Button
          label={i18n.t('invite')}
          disabled={row.is_invited}
          size="small"
          variant={hovered ? 'primary' : 'secondary'}
          style={{ width: 118, height: 32, justifyContent: 'center' }}
          onClick={(): void => {
            dispatch(employeesInviteLoad(row.id))
          }}
        />
      </Table.Cell>
    </Table.Row>
  )
}

export default Row
